import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    // ChunkLoadError means a new deployment rotated the JS filenames — reload to get fresh chunks
    const isChunkError = error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('Failed to fetch dynamically imported module') ||
      error?.message?.includes('Importing a module script failed');
    if (isChunkError) {
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-screen px-4" style={{ background: 'var(--bg)' }}>
          <div className="max-w-md w-full rail-card p-8">
            <div className="text-center">
              <div className="mb-4">
                <svg className="mx-auto h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <h2 className="font-display text-xl font-semibold mb-2" style={{ color: 'var(--text)' }}>
                Something went wrong
              </h2>
              <p className="mb-6" style={{ fontSize: 14, color: 'var(--muted-fg)' }}>
                Something broke on this page. Refreshing usually fixes it.
              </p>
              <div className="flex gap-3 justify-center">
                <button
                  onClick={() => window.location.reload()}
                  className="btn-rail-primary" style={{ padding: '9px 16px', fontSize: 13, borderRadius: 9 }}
                >
                  Refresh
                </button>
                <button
                  onClick={() => window.location.href = '/'}
                  className="btn-rail-secondary" style={{ padding: '9px 16px', fontSize: 13, borderRadius: 9 }}
                >
                  Go to tickets
                </button>
              </div>
              {(process.env.NODE_ENV === 'development' || (process.env.REACT_APP_VERSION || '').includes('staging')) && this.state.error && (
                <div className="mt-6 p-4 bg-red-50 rounded text-left">
                  <p className="text-xs font-mono text-red-800 break-all">
                    {this.state.error.toString()}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
